export const PencilIcon = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="20"
			height="20"
			viewBox="0 0 20 20"
			fill="none"
		>
			<path
				d="M11.0495 3L4.2078 10.2417C3.94947 10.5167 3.69947 11.0583 3.64947 11.4333L3.34114 14.1333C3.2328 15.1083 3.9328 15.775 4.89947 15.6083L7.5828 15.15C7.9578 15.0833 8.4828 14.8083 8.74114 14.525L15.5828 7.28334C16.7661 6.03334 17.2995 4.60834 15.4578 2.86667C13.6245 1.14167 12.2328 1.75 11.0495 3Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeMiterlimit="10"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M9.9082 4.20833C10.2665 6.50833 12.1332 8.26666 14.4499 8.49999"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeMiterlimit="10"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M2.5 18.3333H17.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeMiterlimit="10"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};
